export default __webpack_public_path__ + "static/media/bosnia-and-herzegovina.7845072d.png";